import Links from '../components/Links';
import PageLayout from '../components/pageLayout';

function LinksPage() {
    return (
        <PageLayout children={<Links />} />
    );
}

export default LinksPage;
